module.exports = __webpack_public_path__ + "media/Text_quote_left.54297a13.mp4";